const SCROLLBAR_SIZE = {
  width: 10,
};

export default SCROLLBAR_SIZE;
